// Refactored CustomCourseRequest.jsx — mobilfreundlich & klar strukturiert + dynamische Themenfilterung

import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import CourseCard from "../components/CourseCard";
import ICONS from "../config/icon";
import SalesSection from "./SalesSection";
import { useInsertName } from "./utils/helpers";
import Preloader from "../components/Preloader";
import PaperBG from "../kits/DesignKit/PaperBG";
import { MonoButton } from "../kits";
import SeoHelmet from "./SeoHelmet";


import { generateCourseSchema } from "./utils/seoSchema";
import { ICON_IMAGE_URLS } from "./utils/iconImageMap";


// SEO
import CustomCourseRequestPr from "./CustomCourseRequestPr";
import ModalWrapper from "./utils/ModalWrapper";
import { Helmet } from "react-helmet";
import { buildFAQData } from "./utils/seoSchema";



import RoughBorder from "../kits/LayoutKit/RoughBorder";

// MinoBreDcrumbs



function normalizeDescription(desc) {
  if (Array.isArray(desc)) return desc;
  if (typeof desc === "string") {
    let str = desc.trim();
    // Versuche, den String als JSON zu parsen:
    try {
      const parsed = JSON.parse(str);
      if (Array.isArray(parsed)) return parsed;
    } catch (e) {}
    // Fallback: splitte an Kommas
    if (str.startsWith("[") && str.endsWith("]")) str = str.slice(1, -1);
    return str
      .split(",")
      .map(s => s.replace(/^"|"$/g, '').trim())
      .filter(Boolean);
  }
  return [String(desc)];
}

const generateSlug = (title) => {
  return title
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
};

const keywordMapping = {
  "2D": ["illustrator", "photoshop", "indesign", "after effects"],
  "3D": ["blender", "cinema 4d", "3d", "render"],
  "Web": ["html", "css", "web", "frontend", "nextjs", "tailwind", "react"],
  "Media": ["video", "after effects", "animation", "schnitt"],
  "Entwickler": ["javascript", "react", "angular", "sql", "api", "backend"],
};

const faqData = buildFAQData(keywordMapping);
// ...innerhalb deiner Komponente:



function Courses() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const categoryParam = params.get("category") || "all";
  const gridRef = useRef(null);
  const [highlightGrid, setHighlightGrid] = useState(false);
  const [courses, setCourses] = useState([]);
  const [filteredCourses, setFilteredCourses] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [message, setMessage] = useState("");
  const [email, setEmail] = useState("");
  
  const categories = ["all", "2D", "3D", "Web", "Media", "Entwickler"];

  const seoByCategory = {
  "2D": {
    title: "2D-Design-Kurse mit Illustrator, Photoshop & mehr",
    description: "Lerne 2D-Grafik mit echten Projekten – von Profis für Gestalter.",
  },
  "3D": {
    title: "3D-Kurse mit Blender & Cinema 4D",
    description: "Modelle, Renderings & Animation lernen – direkt am Praxisprojekt.",
  },
  Web: {
    title: "Web-Entwicklung lernen: HTML, CSS, React",
    description: "Vom Code zur Seite – Web-Kurse mit echten Resultaten.",
  },
  // ...
};

const seo = seoByCategory[categoryParam] || {
  title: "Alle Kurse – BITTER. Projektorientiert & Echt",
  description: "Wähle aus echten Kursprojekten für Medien, Web, 3D und Entwicklung.",

};

useEffect(() => {
  // wir öffnen das Modal nur, wenn
  // - ein Suchbegriff gesetzt ist (searchTerm !== "")
  // - es **keine** gefilterten Kurse gibt
  if (searchTerm.trim() !== "" && filteredCourses.length === 0) {
    setShowModal(true);
  }
}, [searchTerm, filteredCourses]);

  useEffect(() => {
    fetch('https://www.denisbitter.de/stage01/api/get_courses.php')
      .then((response) => {
        if (!response.ok) throw new Error(`Fehler beim Laden der Kurse: ${response.status}`);
        return response.json();
      })
      .then((data) => {
        if (!data.success || !Array.isArray(data.data)) throw new Error("Ungültige Kursdaten");
        const params = new URLSearchParams(location.search);
        const categoryParam = params.get("category");

        if (categoryParam) {
          setSelectedCategory(categoryParam);
         
        }
    const coursesWithSlugs = data.data.map((course) => ({
  ...course,
  slug: course.slug || generateSlug(course.title),
  description: normalizeDescription(course.description),
}));

        setCourses(coursesWithSlugs);
        setFilteredCourses(coursesWithSlugs);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Fehler beim Abrufen der Kurse:", err.message);
        setError(err.message);
        setShowModal(true);
        setLoading(false);
      });
  }, []);


    // ...innerhalb deiner Komponente:
const inputRef = useRef(null);

  useEffect(() => {
  const params = new URLSearchParams(location.search);
  const categoryParam = params.get("category");
  if (courses.length > 0 && categoryParam) {
    filterCourses(searchTerm, categoryParam);
    // sanft scrollen zum Grid
  setTimeout(() => {
    gridRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
    setHighlightGrid(true);
    setTimeout(() => {
      setHighlightGrid(false);
    }
    , 400); // Highlight für 1 Sekunde
  }, 400); // kleiner Delay, damit das Grid auch sicher gerendert ist

  }
}, [courses, location.search]);

  const handleSearch = (event) => {
    const value = event.target.value.toLowerCase();
    setSearchTerm(value);
    filterCourses(value, selectedCategory);
  };

const handleCategoryClick = (category) => {
  setSelectedCategory(category);
  setSearchTerm("");
  filterCourses("", category);
};

const handleCloseModal = () => {
  setShowModal(false);
  setSearchTerm("");      // ← Suchfeld leeren!
  filterCourses("", selectedCategory); // Ergebnisse wieder zeigen
};

  const filterCourses = (term, category) => {
  const searchWords = term
    .toLowerCase()
    .split(" ")
    .map(word => word.trim())
    .filter(Boolean);

  const categoryKeywords = keywordMapping[category] || [];

  const filtered = courses.filter((course) => {
    const descriptionArray = Array.isArray(course.description)
      ? course.description
      : [course.description].filter(Boolean);

    const allContent = [course.title, course.slug, ...descriptionArray].join(" ").toLowerCase();

    // ALLE Suchwörter müssen im Kurs-Content vorkommen
    const matchesSearch =
      searchWords.length === 0 || searchWords.every(word => allContent.includes(word));

    // Mindestens ein Kategorie-Keyword reicht
    const matchesCategory =
      category === "all" ||
      categoryKeywords.some(keyword => allContent.includes(keyword));

    return matchesCategory && matchesSearch;
  });

  setFilteredCourses(filtered);
};



  if (loading) return <Preloader />;
  const defaultImage = "https://www.denisbitter.de/images/icons/default.png";
  const courseSchemas = filteredCourses.map((course) => generateCourseSchema(course));
  return (
    <PaperBG>

 <SeoHelmet
  title={seo.title}
  description={seo.description}
  url="https://www.denisbitter.de/courses"
  image={defaultImage}
/>

 <Helmet>
  {courseSchemas.map((schema, index) => (
    <script key={index} type="application/ld+json">
      {JSON.stringify(schema)}
    </script>
  ))}
</Helmet>




      <section className="py-1 relative">
   
   
        <div className="container mx-auto px-6 text-center relative z-20 py-10">
          <h2 className="text-sm sm:text-xl font-mono mb-2">
            Echte Projekt-Kurse für <br />
            Media-, Web- und Entwickler Menschen <br />für <span className="text-brand bg-gray-950 font-semibold pl-2 pr-2">jedes</span> Lernziel und Problem
          </h2>
        
 <div className="relative w-full md:w-1/2 mx-auto mb-8 mt-10 z-10 font-mono text-xs flex items-center justify-center">
    {/* Das Input bekommt KEINE Tailwind-border mehr */}
    <input
      ref={inputRef}
      type="text"
      placeholder="3D, Web, Programmierung, Adobe After Effects..."
      autoComplete="off"
      autoCorrect="off"
      className="w-full text-center text-xs sm:text-sm px-4 py-2 font-mono rounded-lg focus:outline-none focus:ring-1 focus:ring-gray-800 bg-white relative z-20"
      value={searchTerm}
      onChange={handleSearch}
      style={{ background: "transparent" }}
    />
    {/* RoughBorder-Overlay */}
    <div>
    <RoughBorder
      parentRef={inputRef}
      radius={10}
      padding={2}
        color="#AC8E66"      // z.B. Tailwind Zen-Gelb
      strokeWidth={0.3}
      roughness={1}
      bowing={2}
      style={{ pointerEvents: "none", zIndex: 10, position: "absolute", left: 0, top: 0 }}
    />
    </div>
  </div>

          <div className="flex flex-wrap justify-center gap-4 sm:mb-12 mb-10">{categories.map((category, index) => (
  <MonoButton
    key={index}
    className={`px-4 py-2 rounded-full shadow-md text-xs hover:bg-gray-50 text-amber-100 hover:text-gray-950 ${
      selectedCategory === category ? "bg-black text-brand" : "bg-gray-50"
    }`}
    onClick={() => handleCategoryClick(category)}
  >
    {category}
  </MonoButton>
))}



            <MonoButton onClick={() => setShowModal(true)} 
            type="button"
            className="
        
            text-xs
            px-4 py-2
         
          
            font-mono 
         
    
     
            rounded-full shadow-md">
              Kursanfrage stellen 
            </MonoButton >
          </div>




          <div ref={gridRef} 
          className={`grid gap-8 grid-cols-1 md:grid-cols-3 transition-shadow duration-700 ${highlightGrid 
            ? ""
            : "border-transparent"
            }`}>
            {filteredCourses.length > 0 ? (
              filteredCourses.map((course) => (
                <CourseCard
                  key={course.id}
                  course={course}
                  icon={ICONS[course.icon] || ICONS.default}
                  slug={course.slug}
                />
              ))
            ) : (
              <div className="text-center font-mono">
                {showModal && (
   

      <ModalWrapper onClose={handleCloseModal}>
  <CustomCourseRequestPr navbarHeight={0} onClose={handleCloseModal} />
</ModalWrapper>
    /* weitere Props, z.B. name, prefill, … */
                    
                  )}
              </div>
            )}
          </div>

          {showModal && (
            <div className="fixed inset-0 bg-white/60 backdrop-blur-md z-40 flex items-center  justify-center">
              <div className="w-full max-w-xl px-4">
 <ModalWrapper onClose={handleCloseModal}>
  <CustomCourseRequestPr onClose={handleCloseModal} />
</ModalWrapper>
                <div className="mt-1 text-center font-mono text-xs mx-auto">
                  <MonoButton  onClick={() => setShowModal(false)}>Beenden</MonoButton>
                </div>
              </div>
            </div>
          )}
        </div>
      </section>

    </PaperBG>
  );
}

export default Courses;